export const ADD_LIST_USER = 'ADD_LIST_USER';
export const ADD_USER = 'ADD_USER';
export const UPDATE_USER = 'UPDATE_USER';


export const ADD_LIST_USER_CHILD = 'ADD_LIST_USER_CHILD';
export const ADD_USER_CHILD = 'ADD_USER_CHILD';
export const UPDATE_USER_CHILD = 'UPDATE_USER_CHILD';